import * as React from 'react';
import { connect } from 'react-redux';
import NewSettingPopup from '../common/NewSettingPopup';
import SettingPopupTabs from '../common/setting-popup-tabs/SettingPopupTabs';
import SettingPopupTabList from '../common/setting-popup-tabs/SettingPopupTabList';
import SettingPopupTab from '../common/setting-popup-tabs/SettingPopupTab';
import SettingPopupTabPanel from '../common/setting-popup-tabs/SettingPopupTabPanel';
import TextboxSettingPanel from './TextboxSettingPanel';
import { AppStates } from '../../reducers/app';
import { Dispatch, Action } from 'redux';
import UIAction from '../../actions/ui/UIAction';
import { CurrentTool } from '../../reducers/ui/ui';
import TextboxUIAction from '../../actions/ui/TextboxUIAction';
import TextboxToolIconButton from './TextboxToolIconButton';
import VerticalBorder from '../common/VerticalBorder';
import { getBasePath } from '../../utils/browser';
import { zIndex } from '../../constants';
import TextboxIconImage from './TextboxIconImage';

interface TextboxSettingDialogProps {
  readonly selectedTabIndex: number;
  readonly onClose: () => void;
  readonly dispatch: Dispatch<Action>;
}

const handleOnClickTab = (
  index: number,
  event: React.MouseEvent,
  dispatch: Dispatch<Action>,
) => {
  event.stopPropagation();
  UIAction.setCurrentTool(CurrentTool.Textbox, dispatch);
  TextboxUIAction.selectTextboxTool(index, dispatch);
};

const wrapperStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'row',
};

const mainToolIconStyle: React.CSSProperties = {
  width: '90px',
  height: '90px',
  margin: '24px',
  backgroundColor: '#fff',
  border: '2px #9f9f9f solid',
  display: 'flex',
  position: 'relative',
};

const contentsContainerStyle: React.CSSProperties = {
  maxHeight: '642px',
  minHeight: '250px',
};

const TextboxSettingDialog: React.SFC<TextboxSettingDialogProps> = React.memo((props) => {
  const { onClose, selectedTabIndex, dispatch } = props;

  const baseDir = getBasePath();

  const settingPopupTabStyle: React.CSSProperties = {
    width: '71px',
    height: '80px',
    backgroundImage: `url('${baseDir}/images/setting-popup/setting-popup-inactive-tab-bg.png')`,
    backgroundSize: 'contain',
    margin: 0,
    border: 0,
    transform: 'translateX(2px)',
    zIndex: zIndex.settingPopupTab,
    paddingLeft: '5px',
  };

  const activeSettingPopupTabStyle: React.CSSProperties = {
    backgroundImage: `url('${baseDir}/images/setting-popup/setting-popup-active-tab-bg.png')`,
    paddingLeft: 0,
  };

  const tabStyle: React.CSSProperties = {
    width: '48px',
    height: '48px',
    minWidth: '48px',
    backgroundColor: 'rgba(0, 0, 0, 0)',
    marginLeft: '12px',
  };

  const tabSVGStyle: React.CSSProperties = {
    width: '44px',
    height: '44px',
  };

  return (
    <SettingPopupTabs
      vertical={true}
      initialSelectedTabIndex={selectedTabIndex}>
      <NewSettingPopup
        title="テキストボックス設定"
        imgName="text_txtbox_setting"
        onClose={onClose}
        renderOutsideLeft={() => (
          <SettingPopupTabList style={{ flexDirection: 'column', marginTop: '67px' }}>
            <SettingPopupTab
              style={settingPopupTabStyle}
              selectedStyle={activeSettingPopupTabStyle}
              highlightStyle={activeSettingPopupTabStyle}
              onClick={ev => handleOnClickTab(0, ev, dispatch)}>
              <TextboxToolIconButton buttonNumber={0}
                                     title="テキストボックス1"
                                     style={tabStyle}
                                      svgStyle={tabSVGStyle}/>
            </SettingPopupTab>
            <SettingPopupTab
              style={settingPopupTabStyle}
              selectedStyle={activeSettingPopupTabStyle}
              highlightStyle={activeSettingPopupTabStyle}
              onClick={ev => handleOnClickTab(1, ev, dispatch)}>
              <TextboxToolIconButton buttonNumber={1}
                                     title="テキストボックス2"
                                     style={tabStyle}
                                      svgStyle={tabSVGStyle}/>
            </SettingPopupTab>
            <SettingPopupTab
              style={settingPopupTabStyle}
              selectedStyle={activeSettingPopupTabStyle}
              highlightStyle={activeSettingPopupTabStyle}
              onClick={ev => handleOnClickTab(2, ev, dispatch)}>
              <TextboxToolIconButton buttonNumber={2}
                                     title="テキストボックス3"
                                     style={tabStyle}
                                      svgStyle={tabSVGStyle}/>
            </SettingPopupTab>
          </SettingPopupTabList>
        )}>
        <div style={wrapperStyle}>
          <div style={mainToolIconStyle} >
            <TextboxIconImage buttonNumber={selectedTabIndex}
              svgStyle={{ width: '86px', height: '86px' }} />
          </div>
          <VerticalBorder />
          <SettingPopupTabPanel style={contentsContainerStyle}>
            <TextboxSettingPanel />
            <TextboxSettingPanel />
            <TextboxSettingPanel />
          </SettingPopupTabPanel>
        </div>
      </NewSettingPopup>
    </SettingPopupTabs>
  );
});

const mapStateToProps = (appStates: AppStates) => (
  { selectedTabIndex: appStates.ui.textbox.selected }
);

export default connect(mapStateToProps)(TextboxSettingDialog);
